// The microphone capture processor, as source text compiled into a Blob URL at runtime.
//
// It lives as a string because an AudioWorklet module has to be fetched from a URL, and a separate
// asset file would have to survive the Vite build, the Storybook build and the test runner. The code
// is deliberately tiny: buffer the incoming quanta, post a copy, repeat.

import { ASSISTANT_MIC_SAMPLE_RATE } from './audioUtils'

/** Samples per message. At 16 kHz this is 64 ms — small enough to stay responsive, big enough to be cheap. */
const FRAMES_PER_MESSAGE = 1024

export const ASSISTANT_MIC_PROCESSOR_NAME = 'assistant-mic-processor'

export const ASSISTANT_MIC_PROCESSOR_SOURCE = `
class AssistantMicProcessor extends AudioWorkletProcessor {
  constructor() {
    super()
    this.buffer = new Float32Array(${FRAMES_PER_MESSAGE})
    this.offset = 0
  }

  process(inputs) {
    const channel = inputs[0] && inputs[0][0]
    if (!channel) return true

    for (let i = 0; i < channel.length; i++) {
      this.buffer[this.offset++] = channel[i]
      if (this.offset < this.buffer.length) continue
      // Transferring the buffer would detach it, so post a copy and keep writing into ours.
      this.port.postMessage(this.buffer.slice())
      this.offset = 0
    }
    return true
  }
}

registerProcessor('${ASSISTANT_MIC_PROCESSOR_NAME}', AssistantMicProcessor)
`

/** Requested capture rate. The browser resamples natively, which beats decimating in JS. */
export const ASSISTANT_MIC_CONTEXT_OPTIONS: AudioContextOptions = {
  sampleRate: ASSISTANT_MIC_SAMPLE_RATE,
  latencyHint: 'interactive'
}
